import { Switch as BSwitch } from '@base-ui/react/switch'
import clsx from 'clsx'
import type React from 'react'

export interface SwitchProps
  extends Pick<
    React.InputHTMLAttributes<HTMLInputElement>,
    'className' | 'disabled' | 'id' | 'name'
  > {
  checked?: boolean
  defaultChecked?: boolean
  onChange?: (checked: boolean) => void
}

export function Switch({
  className,
  checked,
  defaultChecked,
  onChange,
  id,
  ...props
}: SwitchProps) {
  return (
    <BSwitch.Root
      checked={checked}
      defaultChecked={defaultChecked}
      onCheckedChange={onChange}
      id={id}
      className={clsx(
        // Track
        'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full transition-colors duration-200',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forest focus-visible:ring-offset-2',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        // Unchecked
        'bg-gray-stroke',
        // Checked
        'data-[checked]:bg-forest',
        className
      )}
      {...props}
    >
      <BSwitch.Thumb
        className={clsx(
          'absolute top-0.5 left-0.5 h-5 w-5 rounded-full bg-white shadow-sm transition-transform duration-200',
          'data-[checked]:translate-x-5'
        )}
      />
    </BSwitch.Root>
  )
}
